module.exports = __webpack_public_path__ + "static/media/db.09d00669.png";